function ActorPage() {
    /**
     *
     */
    ActorPage.prototype.initialize = function (console, actor) {
        this.id = "actor";
        this.console = console;
        this.actor = actor;

        return this;
    };

    /**
     *
     */
    ActorPage.prototype.show = function () {
        var deferred = $.Deferred();

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    ActorPage.prototype.leave = function () {
    };
}
